<template>
  <div class="right_col" role="main">
    <div class="row">
      <h3>新增特約商家</h3>
      <hr />
    </div>
    <div class="row">
      <h4>
        使用說明：
        <p>請先新增特約商家，當新增完後，亦可增加APP定點叫車設定與聯絡電話</p>
      </h4>
    </div>
    <hr />
    <h2>商家基本資料</h2>
    <div
      style="
        background: white;
        padding: 10px;
        border: 1px #ffac55 solid;
        border-radius: 5px;
      "
    >
      <el-row :gutter="20">
        <el-col :span="4">
          <h4>商家名稱: *</h4>
          <el-input v-model="store.name" placeholder="商家名稱"></el-input>
        </el-col>
        <el-col :span="4">
          <h4>聯絡人: *</h4>
          <el-input
            v-model="store.contactPerson"
            placeholder="聯絡人"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <h4>備註:</h4>
          <el-input v-model="store.note" placeholder="備註"></el-input>
        </el-col>
        <el-col :span="4">
          <h4>企業折扣:</h4>
          <el-input
            v-model="store.companyDiscount"
            placeholder="企業折扣"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <h4>司機折扣:</h4>
          <el-input
            v-model="store.driverDiscount"
            placeholder="司機折扣"
          ></el-input>
        </el-col>
        <el-col :span="4">
          <el-button
            type="primary"
            @click="addStore()"
            :loading="isStoreLoading"
          >
            新增商家資料
          </el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import Group from '../../assets/js/libs/Group'
var group = new Group()
import checkPointInKml from '@/assets/js/tool/checkPointInKml.js'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import StoreAPI from '../../assets/js/libs/Store'
var store = new StoreAPI()
export default {
  name: 'AddStore',
  data() {
    return {
      store: {
        name: '',
        contactPerson: '',
        driverDiscount: 0,
        companyDiscount: 0,
        note: '',
      },
      isStoreLoading: false,
    }
  },
  methods: {
    async addStore() {
      let regex = /^[0-9\s]*$/
      if (!regex.test(this.store.driverDiscount)) {
        alert('企業折扣格式錯誤')
        return
      }
      if (!regex.test(this.store.companyDiscount)) {
        alert('司機折扣格式錯誤')
        return
      }
      BehaviorRecorder.record(
        '點擊',
        '特約商家',
        '新增商家資料 - ' +
          this.store.name +
          '&&商家名稱:' +
          this.store.name +
          '&&聯絡人:' +
          this.store.contactPerson +
          '&&備註:' +
          this.store.note +
          '&&企業折扣:' +
          this.store.companyDiscount +
          '&&司機折扣:' +
          this.store.driverDiscount,
      )
      if (confirm('確定新增')) {
        let result = await store.createStore(this.store)
        if (result.success) {
          alert(result.message.result)
          this.store.name = ''
          this.store.note = ''
          this.store.contactPerson = ''
          this.store.driverDiscount = 0
          this.store.companyDiscount = 0
          this.$router.replace({
            name: 'EditStore',
            params: {
              id: result.message.storeId,
              isNewStore: 'true',
            },
          })
          return
        }
        alert('新增失敗' + result.message)
      }
    },
  },
  mounted() {
    // this.initMap()
  },
}
</script>

<style scoped>
/* Always set the map height explicitly to define the size of the div
       * element that contains the map. */
#map1 {
  height: 80%;
  width: 200px;
}
/* Optional: Makes the sample page fill the window. */
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
h4 {
  background-color: bisque;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/pages/specialContract/AddStore.vue